export function isLanguageSupported(language) {
  return language === 'en' || language === 'es'
}
